/**
 * Репозиторий для работы с логами в IndexedDB
 */
import { db, type LogRecord } from './db'
import { v4 as uuidv4 } from 'uuid'

export class LogsRepo {
  /**
   * Сохраняет лог
   */
  static async save(
    level: 'info' | 'warn' | 'error',
    message: string,
    metadata?: Record<string, unknown>
  ): Promise<string> {
    const id = uuidv4()
    const record: LogRecord = {
      id,
      level,
      message,
      timestamp: new Date().toISOString(),
      metadata,
    }
    // Только атомарная запись — без дорогого cap-check на каждый вызов.
    // Периодическая очистка (раз в час, окно 24ч) выполняется в consoleCapture.ts.
    // Дополнительная защита: clearLogsBuffer() + db.logs.clear() при команде clear_cache.
    await db.logs.add(record)
    return id
  }

  /**
   * Получает логи с фильтрами
   */
  static async getAll(filters?: {
    level?: 'info' | 'warn' | 'error'
    limit?: number
  }): Promise<LogRecord[]> {
    let query = db.logs.orderBy('timestamp').reverse()
    
    if (filters?.level) {
      query = query.filter((l) => l.level === filters.level)
    }
    
    const limit = filters?.limit || 100
    return await query.limit(limit).toArray()
  }

  /**
   * Очищает старые логи
   */
  static async clearOld(daysOld: number = 7): Promise<number> {
    const cutoffDate = new Date()
    cutoffDate.setDate(cutoffDate.getDate() - daysOld)
    const cutoffISO = cutoffDate.toISOString()
    
    const oldLogs = await db.logs
      .where('timestamp')
      .below(cutoffISO)
      .toArray()
    
    const ids = oldLogs.map((l) => l.id)
    await db.logs.bulkDelete(ids)
    
    return ids.length
  }
}

